import { App } 		from 'vue'
import VueCal from './index.vue'


export default {
	install: (app: App) => {

		app.component('Vue-cal', VueCal)
	}
}